import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { EmptyState } from "@/components/storefront/common";
import { formatINR } from "@/lib/format";
import { resolveMediaUrl, handleMediaError } from "@/lib/media";
import { Package, ChevronRight } from "lucide-react";

export default function AccountOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/orders").then(({ data }) => setOrders(data.orders)).finally(() => setLoading(false)); }, []);

  if (!loading && orders.length === 0)
    return <EmptyState icon={Package} title="No orders yet" text="When you place an order it will appear here."><Link to="/shop" className="bg-slate-900 text-white font-semibold px-5 py-2.5 rounded-lg">Start Shopping</Link></EmptyState>;

  return (
    <div className="space-y-3">
      <h2 className="font-semibold text-slate-900 text-lg mb-2">Your Orders</h2>
      {orders.map((o) => (
        <Link key={o.id} to={`/account/orders/${o.id}`} data-testid={`order-row-${o.orderNumber}`}
          className="flex items-center gap-4 p-4 rounded-xl border border-slate-200 bg-white hover:border-amber-400 transition">
          <div className="flex -space-x-3">
            {o.items.slice(0, 3).map((it) => <img key={it.id} src={resolveMediaUrl(it.image)} alt="" onError={handleMediaError} className="h-12 w-12 rounded-lg border-2 border-white bg-slate-50 object-contain" />)}
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-mono font-semibold text-sm text-slate-900">{o.orderNumber}</p>
            <p className="text-xs text-slate-500">{o.items.length} item(s) · {new Date(o.createdAt).toLocaleDateString("en-IN")}</p>
            <span className="inline-block text-[11px] font-semibold px-2 py-0.5 rounded bg-amber-50 text-amber-700 mt-1">{o.status.replace(/_/g, " ")}</span>
            <p className="text-xs text-slate-500 mt-1">
              {o.paymentMethod === "COD" ? "Cash on Delivery" : "Razorpay"} · {o.paymentStatus || "PENDING"}
              {o.paymentMethod === "COD" && o.paymentStatus !== "PAID" &&
                ` · ${formatINR(o.amountDue ?? o.codAmountDue ?? o.total)} due on delivery`}
            </p>
          </div>
          <div className="text-right">
            <p className="font-mono font-bold text-slate-900">{formatINR(o.total)}</p>
            <ChevronRight className="h-4 w-4 text-slate-400 ml-auto mt-1" />
          </div>
        </Link>
      ))}
    </div>
  );
}
